import React, { PureComponent } from "react"
import classnames from "classnames"
import Customizer from "../components/customizer/Customizer"
import Sidebar from "./components/menu/Sidebar"
import Navbar from "./components/navbar/Navbar"
import Footer from "./components/Footer"
import { connect } from "react-redux"
import {
  changeMode,
  collapseSidebar,
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop
} from "../store/actions/customizer/index"
import API from "../components/API"
import { getLocalSessionId } from "../utils/localStorageConstants"

class VerticalLayout extends PureComponent {
  constructor(props) {
    super(props)
  }
    state = {
      width: window.innerWidth,
      sidebarState: this.props.app?.customizer?.sidebarCollapsed || false,
      layout: this.props.app?.customizer?.theme || 'light',
      collapsedContent: this.props.app?.customizer?.sidebarCollapsed || false,
      sidebarHidden: false,
      currentLang: "en",
      appOverlay: false,
      customizer: false,
      currRoute: this.props.location?.pathname || '/',
      suggestions: {}
    }
    collapsedPaths = []
    mounted = false
    navbarProps = {
      ...this.props
    }
  

  updateWidth = () => {
    if (this.mounted) {
      this.setState(prevState => ({
        width: window.innerWidth
      }))
    }
  }

  handleCustomizer = bool => {
    this.setState({ customizer: bool })
  }

  componentDidMount() {
    this.mounted = true
    const {
      location,
      app
    } = this.props

    const pathname = location?.pathname
    const theme = app?.customizer?.theme
    const direction = app?.customizer?.direction

    if (this.mounted) {
      if (typeof window !== "undefined") {
        window.addEventListener("resize", this.updateWidth, false)
      }
      
      if (pathname && this.collapsedPaths?.includes(pathname)) {
        this.props.collapseSidebar(true)
      }

      let layout = theme || 'light'
      let dir = direction || 'ltr'
      
      if (dir === "rtl") {
        document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
      } else {
        document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
      }

      if (layout === "dark") {
        document.body.classList.add("dark-layout")
      } else if (layout === "semi-dark") {
        document.body.classList.add("semi-dark-layout")
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      location,
      app
    } = this.props

    const pathname = location?.pathname
    const theme = app?.customizer?.theme
    const sidebarCollapsed = app?.customizer?.sidebarCollapsed

    let layout = theme || 'light'
    
    if (this.mounted) {
      if (layout === "dark") {
        document.body.classList.remove("semi-dark-layout")
        document.body.classList.add("dark-layout")
      }
      if (layout === "semi-dark") {
        document.body.classList.remove("dark-layout")
        document.body.classList.add("semi-dark-layout")
      }
      if (layout !== "dark" && layout !== "semi-dark") {
        document.body.classList.remove("dark-layout", "semi-dark-layout")
      }

      if (prevProps.app?.customizer?.sidebarCollapsed !== sidebarCollapsed) {
        this.setState({
          collapsedContent: sidebarCollapsed,
          sidebarState: sidebarCollapsed
        })
      }

      if (pathname && 
          prevProps.app?.customizer?.sidebarCollapsed === sidebarCollapsed &&
          pathname !== prevProps.location?.pathname) {
        if (this.collapsedPaths?.includes(pathname)) {
          this.props.collapseSidebar(true)
        } else {
          this.props.collapseSidebar(false)
        }
      }
    }
  }

  handleCollapsedMenuPaths = item => {
    if (item && !this.collapsedPaths?.includes(item)) {
      this.collapsedPaths.push(item)
    }
  }

  toggleSidebarMenu = val => {
    this.setState({
      sidebarState: !this.state.sidebarState,
      collapsedContent: !this.state.collapsedContent
    })
  }

  sidebarMenuHover = val => {
    this.setState({
      sidebarState: val
    })
  }

  handleSidebarVisibility = () => {
        if (this.mounted) {
      if (typeof window !== "undefined") {
        window.addEventListener("resize", () => {
          if (this.state.sidebarHidden) {
            this.setState({
              sidebarHidden: !this.state.sidebarHidden
            })
          }
        })
      }
      this.setState({
        sidebarHidden: !this.state.sidebarHidden
      })
    }
  }

  componentWillUnmount() {
    this.mounted = false
  }

  handleCurrentLanguage = lang => {
    this.setState({
      currentLang: lang
    })
  }

  handleAppOverlay = value => {
    if (value) {
      API.globalSearch(value, getLocalSessionId())
        .then(res => res.json())
        .then(res => {
          if (res.responseCode === 200) {
            this.setState({
              suggestions: res.result,
              appOverlay: true
            })
            this.navbarProps = {
              ...this.navbarProps,
              suggestions: res.result
            }
          } else {
            this.setState({
              appOverlay: false,
              suggestions: []
            })
          }
        })
        .catch(err => {
          this.setState({
            appOverlay: false,
            suggestions: {}
          })
        })
    }
  }

  handleAppOverlayClick = () => {
    this.setState({
      appOverlay: false
    })
  }

  render() {
    const appProps = this.props.app?.customizer || {}
    const menuThemeArr = [
      "primary",
      "success",
      "danger",
      "info",
      "warning",
      "dark"
    ]

    const sidebarProps = {
      toggleSidebarMenu: this.props.collapseSidebar,
      toggle: this.toggleSidebarMenu,
      sidebarState: this.state.sidebarState,
      sidebarHover: this.sidebarMenuHover,
      sidebarVisibility: this.handleSidebarVisibility,
      visibilityState: this.state.sidebarHidden,
      activePath: this.props.match?.path,
      collapsedMenuPaths: this.handleCollapsedMenuPaths,
      currentLang: this.state.currentLang,
      activeTheme: appProps.menuTheme,
      collapsed: this.state.collapsedContent,
      permission: this.props.permission,
      deviceWidth: this.state.width
    }

    this.navbarProps = {
      ...this.navbarProps,
      toggleSidebarMenu: this.toggleSidebarMenu,
      sidebarState: this.state.sidebarState,
      sidebarVisibility: this.handleSidebarVisibility,
      currentLang: this.state.currentLang,
      changeCurrentLang: this.handleCurrentLanguage,
      handleAppOverlay: this.handleAppOverlay,
      appOverlayState: this.state.appOverlay,
      navbarColor: appProps.navbarColor,
      navbarType: appProps.navbarType,
      searchEnable: false,
      suggestions: this.state.suggestions
    }

    const footerProps = {
      footerType: appProps.footerType,
      hideScrollToTop: appProps.hideScrollToTop
    }

    const customizerProps = {
      customizerState: this.state.customizer,
      handleCustomizer: this.handleCustomizer,
      changeMode: this.props.changeMode,
      changeNavbar: this.props.changeNavbarColor,
      changeNavbarType: this.props.changeNavbarType,
      changeFooterType: this.props.changeFooterType,
      changeMenuTheme: this.props.changeMenuColor,
      collapseSidebar: this.props.collapseSidebar,
      hideScrollToTop: this.props.hideScrollToTop,
      activeMode: appProps.theme,
      activeNavbar: appProps.navbarColor,
      navbarType: appProps.navbarType,
      footerType: appProps.footerType,
      menuTheme: appProps.menuTheme,
      scrollToTop: appProps.hideScrollToTop,
      sidebarState: appProps.sidebarCollapsed
    }

    return (
      <div
        className={classnames(
          `wrapper vertical-layout theme-${appProps.menuTheme}`,
          {
            "menu-collapsed":
              this.state.collapsedContent === true && this.state.width >= 1200,
            "fixed-footer": appProps.footerType === "sticky",
            "navbar-static": appProps.navbarType === "static",
            "navbar-sticky": appProps.navbarType === "sticky",
            "navbar-floating": appProps.navbarType === "floating",
            "navbar-hidden": appProps.navbarType === "hidden",
            "theme-primary": !menuThemeArr?.includes(appProps.menuTheme)
          }
        )}>
        <Sidebar {...sidebarProps} />
        <div
          className={classnames("app-content content", {
            "show-overlay": this.state.appOverlay === true
          })}
          onClick={this.handleAppOverlayClick}>
          <Navbar {...this.navbarProps} />
          <div className="content-wrapper">{this.props.children}</div>
        </div>

        <Footer {...footerProps} />
        {appProps.disableCustomizer !== true ? (
          <Customizer {...customizerProps} />
        ) : null}
        <div
          className="sidenav-overlay"
          onClick={this.handleSidebarVisibility}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    app: state.customizer
  }
}

export default connect(mapStateToProps, {
  changeMode,
  collapseSidebar,
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop
})(VerticalLayout)